import { render, staticRenderFns } from "./light-block.vue?vue&type=template&id=0937c121&"
import script from "./light-block.vue?vue&type=script&lang=js&"
export * from "./light-block.vue?vue&type=script&lang=js&"
import style0 from "./light-block.vue?vue&type=style&index=0&id=0937c121&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports